export default {
  name: "Имя",
  create_resume: {
    validation: {
      required: "Обязательно для заполнения",
      invalid_email: "Неверный формат email",
    },
  },
};
